window.addCaptchaToken = function (token) {
    const ctField = document.getElementById('captcha_token');
    ctField.value = token;
    document.getElementById('captcha_form').submit();
};
